export const COURSES_STATUSES = {
  LIVE: "LIVE",
  DRAFT: "DRAFT",
};

export const ADDING_TYPES = {
  USER: "USER",
  ADMIN: "ADMIN",
};

export const COURSES_TYPES = {
  EQUIPMENT: "EQUIPMENT",
  SOFTWARE: "SOFTWARE",
  GENRE: "GENRE",
};

export const getPublishModalDescription = (title) =>
  `The course <strong>${title}</strong> will become visible for everyone. Users will be able to purchase it. You can edit the course and add new lessons at any time. Changes will be published automatically after saving. Do you want to publish this course?`;

export const UNLIMITED = 'Unlimited'

export const RECOMMENDATIONS_COURSES_COUNT = 2;

export const MAX_COURSES_LIMIT = 100;

export const PROVIDE_FREE_COURSE_TO = {
  NON_CUSTOMER: "NON_CUSTOMER",
  ALL_USERS: "ALL_USERS",
  REFERRAL_SOURCE: "REFERRAL_SOURCE",
};


export const PROVIDE_FREE_COURSE_TO_RADIO = [
  {
    label: "Non Customer",
    value: PROVIDE_FREE_COURSE_TO.NON_CUSTOMER,
  },
  {
    label: "All Users",
    value: PROVIDE_FREE_COURSE_TO.ALL_USERS,
  },
  {
    label: "Referral Source",
    value: PROVIDE_FREE_COURSE_TO.REFERRAL_SOURCE,
  },
];